/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const analyticsMessages = defineMessages({
    loading: {
        id: 'analytics.loading',
        defaultMessage: 'Loading analytics ...'
    },
    complete: {
        id: 'analytics.complete',
        defaultMessage: 'Analytics loaded'
    },
    failed: {
        id: 'analytics.failed',
        defaultMessage: 'Failed to load analytics'
    }
});
